import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { Countries } from './countries.types';
import { I18nService } from '../../i18n/i18n.service';
import { getNames } from 'i18n-iso-countries';

@Injectable({
  providedIn: 'root',
})
export class CountriesService {
  private readonly _countries: Observable<Countries.CountryEntity[]>;

  /*ToDo: check if it can be optimized for async loading */
  constructor(
    private translationService: I18nService,
  ) {
    const countriesList: Countries.CountryEntity[] = Object
      .entries(getNames(this.translationService.selectedLang, { select: 'official' }))
      .map(([code, label]) => ({ code, label }))
      .sort((a, b) => a.label.localeCompare(b.label))

    this._countries = of(countriesList)
      .pipe(
        shareReplay(1),
      );
  }

  public get countries$(): Observable<Countries.CountryEntity[]> {
    return this._countries;
  }
}
